import {
  CustomCursorTypes,
  ArrowTypes,
  EditModes,
  HotkeyScopes,
  TreeDefaultNodeIds,
  hyperFormulaErrorMessages,
  UndoRedoTypes,
} from "../utils/constants";
import { RowTypes, ColumnTypes } from "../components/process-design/cell/CellConstants";
import { v4 as uuidv4 } from "uuid";
import { i18n } from "../main";
import api from "./api";
import { produce } from "immer";
import { ActiveCorners } from "../components/process-design/corner/CornerConstants";

import { arrayMoveImmutable, chunkArray, chunkObject, compressData, trackChanges } from "../utils/array";
import { ProcessTypes } from "../utils/icons";
import RangeSelection from "./RangeSelection";
import deepIs from "deep-is";
import { removePartUntilSymbol } from "../utils/util";

export const rangeSelection = new RangeSelection();
import {
  areArraysEqual,
  getCellId,
  rangeIndexToLabel,
  sortRange,
  splitCellId,
  rangeLabelToIndex,
} from "../components/process-design/cell/Utils";
import { indexToColumn, indexToRow, findDollarParams, isRange, isCell } from "../utils/util";
import { getMaxDataInRange, getInitialRange } from "./helpers/FillHelpers";
import { HyperFormula } from "hyperformula";
import { MyCustomPlugin, MyCustomPluginTranslations } from "../hyperformula-plugin";
import { FillHelper } from "./helpers/FillHelpers";
import { TableHelper } from "./helpers/TableHelper";
import { stateHistory } from "./state-history";
import { funcHelper, rangeToHfFormat } from "./helpers/CellsHelper";
import { authorizationHelper } from "./helpers/AuthorizationHelper";
HyperFormula.registerFunctionPlugin(MyCustomPlugin, MyCustomPluginTranslations);

export let hfInstance;
export let helper;

export const designDefaultProps = {
  arrows: {},
  cellsMetaData: {},
  mergedCells: {},
  styles: {},
  icons: {},
  links: {},
  showGridlines: true,
};
const initialState = {
  filteredCells: {},
  formatPainterRange: [],
  formatPainter: false,
  action: { status: {}, error: {} },
  current: null,
  // arrow info when creating a new activity
  arrow: {
    activeCursor: CustomCursorTypes.Default,
    rowId: null,
    startPlayerId: null,
    endPlayerId: null,
    startPlayerX: 0,
  },
  selectedArrow: null,
  dropIndicator: {
    id: null,
    position: null,
    x: null,
    y: null,
  },
  visibleComment: {
    id: null,
    editMode: false,
  },
  formulaRanges: [],
  activeCellId: null,
  editCell: {
    id: null,
    text: "",
    editMode: EditModes.Disable,
    edited: false,
    formulaRangeSelectionAllowed: false,
    range: "",
    cursorPosition: 0,
    focus: null,
  },
  arrowIndex: -1,
  rangeDragging: {
    id: null,
    position: "", // topleft , topright,bottomleft,bottomright
    cursorType: "",
    range: null,
  },
  activeRangeMainCellCoordinate: null,
  draggingArrow: {
    arrowId: null,
    x: null,
  },
  hScroll: {},
  vScroll: {},
  redrawCanvas: { value: true },
  shouldScroll: { value: true },
  isActiveCellLabelVisible: false,
  showCreateSapDialog: false,
  startDragging: false,
  rangeSelectorCollapse: true,
  currentPermission: null,
};
export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations: {
    SET_FORMAT_PAINTER_DATA(state, { mainRange, isFormatPainterActive }) {
      state.formatPainterRange = mainRange;
      state.formatPainter = isFormatPainterActive;
    },
    SET_ARROW(state, data) {
      state.arrow = produce(state.arrow, (arrow) => {
        Object.assign(arrow, data);
      });
    },
    ADD_COLUMN(state, data) {
      state.current.design.columns = produce(state.current.design.columns, (columns) => {
        columns.splice(data.index, 0, ...data.columns);
      });
    },
    SET_FILTERED_CELLS(state, filteredResults) {
      state.filteredCells = filteredResults;
    },
  },
  actions: {
    /*ACTIONS WITHOUT UNDO REDO FUNCTIONALITY */
    /* Simple State updates */
    async status({ state }, data) {
      state.action.status = produce(state.action.status, (status) => {
        Object.assign(status, data);
      });
    },
    async error({ state }, data) {
      state.action.error = produce(state.action.error, (error) => {
        Object.assign(error, data);
      });
    },
    setActiveCellLabel({ commit, state, dispatch }, data) {
      state.isActiveCellLabelVisible = data;
    },
    setActiveCellId({ commit, state, dispatch }, id) {
      state.activeCellId = id;
    },
    setCreateSapDialogVisibility({ commit, state, dispatch }, data) {
      state.showCreateSapDialog = data;
    },
    setComment({ commit, dispatch, state }, payload) {
      if (!deepIs(state.visibleComment, payload)) state.visibleComment = { ...payload };
    },
    setdropIndicator({ commit, dispatch, state }, data) {
      state.dropIndicator = { ...data };
    },
    resetDropIndicator({ commit, dispatch, state }, data) {
      state.dropIndicator = {
        id: null,
        position: null,
        y: null,
        x: null,
      };
    },
    setRangeDragging({ commit, dispatch, state, getters }, payload) {
      state.rangeDragging = { ...payload };
    },
    setActiveRangeMainCellCoordinate({ commit, dispatch, state }, payload) {
      state.activeRangeMainCellCoordinate = payload;
    },
    setDraggingArrow({ commit, dispatch, state }, payload) {
      state.draggingArrow = { ...payload };
    },
    resetDraggingArrow({ commit, dispatch, state }) {
      state.draggingArrow = {
        arrowId: null,
        x: null,
      };
    },
    setHScroll({ commit, dispatch, state }, hScroll) {
      if (!deepIs(state.hScroll, hScroll)) state.hScroll = hScroll;
    },
    setVScroll({ commit, dispatch, state }, vScroll) {
      if (!deepIs(state.vScroll, vScroll)) state.vScroll = vScroll;
    },
    toggleRedrawCanvas({ commit, dispatch, state }) {
      // object is used; even if the function is called twice still a new value is set
      state.redrawCanvas = { value: !state.redrawCanvas.value };
    },
    setShouldScroll({ commit, dispatch, state }) {
      // object is used; even if the function is called twice still a new value is set
      state.shouldScroll = { value: true };
    },
    setActiveRangeId({ commit, state, dispatch }, activeRangeId) {
      rangeSelection.setActiveRangeId(activeRangeId);
    },
    setSelectedArrow({ commit, dispatch, state }, data) {
      state.selectedArrow = data;
    },
    resetSelectedArrow({ commit, dispatch, state }) {
      state.selectedArrow = null;
      state.arrowIndex = -1;
    },
    async formatPainterData({ commit, getters }, payload) {
      commit("SET_FORMAT_PAINTER_DATA", {
        mainRange: payload.isFormatPainterActive === false ? [] : getters.mainRange,
        isFormatPainterActive: payload.isFormatPainterActive,
      });
    },
    async resetArrow({ commit, dispatch, state }) {
      state.arrow.activeCursor = 0;
    },
    async resetState({ commit, state, rootState, dispatch }) {
      Object.assign(state, { ...initialState });
    },
    setStartDragging({ commit, dispatch, state, getters }, payload) {
      state.startDragging = payload;
    },
    setRangeSelectorCollapse({ commit, dispatch, state, getters }, payload) {
      state.rangeSelectorCollapse = payload;
    },
    /* Complex State Updates */
    async load({ commit, state, getters, rootGetters, rootState, dispatch }, id) {
      try {
        await dispatch("status", { [id]: "loading" });
        await dispatch("error", { [id]: null });

        await dispatch("resetState");
        await dispatch("corners/resetCorners", null, { root: true });
        const resp = await api.get(`designs/${id}?r=${Math.random()}`);
        const { cells_content: cellsContent = [], custom_flow: customFlow, ...rest } = resp.data;

        await dispatch("sheets/loadSheets", { designId: id }, { root: true });
        const currentSheet = rootState.sheets.currentSheet;
        dispatch(
          "rangeStyle/load",
          {
            data: resp.data.design[currentSheet.name].styleTree,
          },
          { root: true }
        );
        const design = resp.data.design[currentSheet.name];
        // get rows and columns from rowMap and columnMap.
        const { rows, columns } = getters.getRowsColumnsFromMaps(design.rowMap, design.columnMap);
        const permissionHelper = authorizationHelper(dispatch, rootState);
        state.currentPermission = await permissionHelper.getProcessBasedPermission(id);
        state.current = {
          ...rest,
          id,
          design: { ...designDefaultProps, ...design, rows, columns },
        };

        hfInstance = HyperFormula.buildFromSheets(cellsContent, {
          licenseKey: "gpl-v3",
          evaluateNullToZero: true,
          context: { rootState, rootGetters },
        });
        // hfInstance.setCellContents({ sheet: currentSheet.sheetId, col: 0, row: 0 }, cellsContent[currentSheet.sheetId]);

        await dispatch("table/loadTables", true, { root: true });
        const namedExpressions = rootState.table.namedExpressions;
        // adding namedExpressions after building HF because we need SheetID and Sheet name
        hfInstance.suspendEvaluation();
        namedExpressions.forEach((element) => {
          if (element.type !== "table") {
            const sheet = rootState.sheets.allSheets.find((item) => item.id === element.sheetId);
            const expression =
              isRange(element.expression) || isCell(element.expression)
                ? `=${sheet.name}!${element.expression}`
                : element.expression;
            hfInstance.addNamedExpression(element.name, expression, element.scope);
          }
        });
        hfInstance.resumeEvaluation();

        hfInstance.rebuildAndRecalculate();
        helper = funcHelper(dispatch, rootState, rootGetters);
        stateHistory.reset();

        dispatch("calculateRowMap");
        dispatch("calculateColumnMap");
        await dispatch("customFlow/load", customFlow, { root: true });
        await dispatch("views/load", id, { root: true });
        dispatch("styleCorner/startStyles", null, { root: true });
        dispatch("smartSearch/load", id, { root: true });
        dispatch("hideNavigationCorner");
        await dispatch("status", { [id]: "loaded" });
        helper.merge.utils.loadMergedCellIds();
        dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
        helper.range.utils.focusFirstVisibleCell();

        if ([ProcessTypes.Normal, ProcessTypes.Posting].includes(state.current.type))
          dispatch(
            "smartSearch/loadProcessPlayers",
            { team: state.current.team, links: state.current.design.links },
            { root: true }
          );

        rootState.processes.isLoading = false; // For process creation

        if (rootState.pdesign.cycleToGrid) {
          dispatch("transferToGrid");
          this.dispatch("pdesign/setCycleToGrid", false, { root: true });
        }

        return design;
      } catch (exp) {
        console.log(exp);
      }
    },
    async updateCustomFlow({ commit, state, dispatch }, value) {
      value = JSON.stringify(value);
      await dispatch("persistProperty", { key: "custom_flow", value });
    },
    calculateRowMap({ state }) {
      state.current.design.rowMap = produce({}, (rowMap) => {
        state.current.design.rows.forEach((row, index) => {
          rowMap[row.id] = { ...row, index };
        });
      });
    },
    calculateColumnMap({ state }) {
      state.current.design.columnMap = produce({}, (columnMap) => {
        state.current.design.columns.forEach((column, index) => {
          columnMap[column.id] = { ...column, index };
        });
      });
    },
    toggleGridlines({ dispatch, state }) {
      state.current.design.showGridlines = !state.current.design.showGridlines;
      dispatch("updateSheetProps", { key: "showGridlines", value: state.current.design.showGridlines });
    },
    swapRangePosition({ commit, dispatch, state, getters }, axis) {
      let position = state.rangeDragging.position;
      position = helper.range.utils.swapRangePosition(axis, position);
      state.rangeDragging = {
        ...state.rangeDragging,
        position,
      };
    },
    updateActiveRange({ commit, state, dispatch, rootState }, { id, title, mode, textRange }) {
      rangeSelection.updateRange(title, id, mode, textRange ?? title);
      const text = rangeSelection.getFormula();
      const wordIndex = text?.indexOf(title);
      let cursorPosition = text.length;
      if (wordIndex !== -1 && title.length > 0) {
        cursorPosition = wordIndex + title.length;
      }
      dispatch("setEditCell", { text, range: title, nameRange: "", cursorPosition });
      state.formulaRanges = rangeSelection.getRanges();
    },
    async setFormulaRange(
      { commit, getters, state, dispatch, rootState, rootGetters },
      { title, isMainRange = true, activeCellId }
    ) {
      title =
        !isMainRange && rangeSelection.ranges.length > 0 && rangeSelection.ranges[0].type !== "nameRange"
          ? rangeSelection.ranges[0].range + " " + title
          : title;
      let textsList;
      const tableHelper = new TableHelper(hfInstance, rootState, rootGetters);
      ({ textsList, title } = await tableHelper.handleNameRanges(title));
      const currentSheetName = rootState.sheets.currentSheet.name;
      rangeSelection.setRanges(title.toUpperCase() ?? "", textsList, currentSheetName?.toUpperCase());
      state.formulaRanges = rangeSelection.getRanges();
      const selectedRage = tableHelper.findSelectedRange();
      const activeRangeId = isMainRange
        ? state.formulaRanges[0]?.id
        : selectedRage
        ? selectedRage?.id
        : state.formulaRanges[state.formulaRanges.length - 1].id;
      rangeSelection.setActiveRangeId(activeRangeId);
      if (activeCellId) {
        state.activeCellId = activeCellId;
        dispatch("initEditCell", activeCellId);
      }
      if (state.current.type !== ProcessTypes.Grid) dispatch("resetSelectedArrow");
      return activeRangeId;
    },

    selectFormulaRange({ commit, state, dispatch }, value) {
      let cleanedRange = removePartUntilSymbol(value, "!");
      const range = sortRange(rangeLabelToIndex(cleanedRange));
      const activeCellId = getCellId(state.current.design.rows[range[1]].id, state.current.design.columns[range[0]].id);
      dispatch("setFormulaRange", { title: cleanedRange, activeCellId });
    },
    resetFormulaRange({ commit, state, dispatch }) {
      rangeSelection.resetRanges();
      state.formulaRanges = [];
      state.activeCellId = null;
      dispatch("setActiveRangeMainCellCoordinate", null);
      rangeSelection.setActiveRangeId("");
      dispatch("resetSelectedArrow");
    },
    selectArrow({ commit, dispatch, state, getters }, amount) {
      const rowId = state.activeCellId.split("_")[0];
      if (!state.current.design.arrows[rowId] || !state.current.design.arrows[rowId].length) return;
      const rowArrows = [...state.current.design.arrows[rowId]];
      state.arrowIndex =
        state.arrowIndex + amount < -1
          ? 2 * rowArrows.length - 1
          : (state.arrowIndex + amount + 2 * rowArrows.length) % (2 * rowArrows.length);

      const [arrowNum, arrowHead] = [Math.floor(state.arrowIndex / 2), state.arrowIndex % 2];
      let arrow = rowArrows[arrowNum];
      if (!arrow) return;

      return dispatch("setSelectedArrow", {
        id: arrow.id,
        rowId,
        arrowHead: arrowHead % 2 === 0,
      });
    },
    async incrementActiveCellIndexInRange({ getters }, { rowDelta = 0, columnDelta = 0 } = {}) {
      const range = getters.mainRange?.range;
      if (!range) return;
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach((func) => func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(helper.range.main.incrementActiveCellInRange(range, rowDelta, columnDelta));
        },
      };

      await stateHistory.snapshot(undoObj, UndoRedoTypes.RangeSelection);
    },
    toggleCornerCellInRange({ commit, dispatch, state, getters }) {
      const range = getters.mainRange?.range;
      if (!range) return;

      state.activeCellId = helper.range.utils.getNextCornerCell(range);
      dispatch("setActiveRangeMainCellCoordinate", getters.getCellCoordinate(state.activeCellId));
      dispatch("initEditCell", state.activeCellId);
    },
    initEditCell({ commit, dispatch, getters, state, rootState, rootGetters }, cellId) {
      const id = state.mergedCellIds[cellId] ? state.mergedCellIds[cellId].replace("_merged", "") : cellId;
      const [rowId, columnId] = splitCellId(id);

      const rowIndex = state.current.design.rowMap[rowId]?.index;
      const columnIndex = state.current.design.columnMap[columnId]?.index;

      let text = rootGetters["cells/cellText"](rowIndex, columnIndex) + "";
      if (state.current.design.cellsMetaData[id]?.formula) {
        const tableHelper = new TableHelper(hfInstance, rootState, rootGetters);
        const cellMetaDataText = state.current.design.cellsMetaData[id]?.formula;
        const absoluteNameRanges = findDollarParams(cellMetaDataText, text);
        let tables = rootGetters["table/getAllTableNameRanges"]();
        ({ text } = tableHelper.convertToRefrenceFormat({ text, cellId, absoluteNameRanges, tables }));
      }
      state.editCell = {
        id,
        text,
        editMode: EditModes.Disable,
        edited: false,
        formulaRangeSelectionAllowed: false,
        range: "",
        nameRange: "",
        cursorPosition: text.length,
      };
    },
    async setEditCell({ commit, dispatch, state, getters, rootState, rootGetters }, payload) {
      let localEditCell = { ...state.editCell, ...payload, edited: true };
      let { text, range, nameRange, cursorPosition, ...others } = localEditCell;

      const tableHelper = new TableHelper(hfInstance, rootState, rootGetters);
      nameRange = rootGetters["table/getLocalNameRangeByDefault"](nameRange);
      ({ nameRange, text } = tableHelper.convertToRefrenceFormat({
        range,
        nameRange,
        text,
        cellId: state.editCell.id,
        cursorPosition,
      }));

      cursorPosition = text !== localEditCell.text ? text.length : cursorPosition;
      localEditCell = { text, range, nameRange, cursorPosition, ...others };
      state.editCell = localEditCell;
    },
    async addFormulaRange({ commit, dispatch, state, getters }, range) {
      const currentRange = state.editCell.range;
      const cursorPosition = state.editCell.cursorPosition;
      const extraFormats = ["A10:B30", "A10", ":A10", "$A$10:$B$30", "$A$10", "$A10:$B30", "$A10", "A$10:B$30", "A$10"];
      let text = state.editCell.text;
      let firstText = text.substring(0, cursorPosition);
      let lastText = text.substring(cursorPosition, text.length);

      // If first part ends with :, remove the last cell reference pattern
      if (firstText.trim().endsWith(":")) {
        firstText = firstText.substring(0, firstText.length - 1);

        for (let format of extraFormats) {
          let pattern = format.replace(/\$/g, "\\$").replace(/[A-Z]/g, "[A-Z]").replace(/\d+/g, "\\d+");

          let regex = new RegExp(pattern + "$");
          if (regex.test(firstText)) {
            firstText = firstText.replace(regex, "");
            break;
          }
        }
      }

      // If last part starts with :, remove the first cell reference pattern
      if (lastText.trim().startsWith(":")) {
        lastText = lastText.substring(1);

        for (let format of extraFormats) {
          let pattern = format.replace(/\$/g, "\\$").replace(/[A-Z]/g, "[A-Z]").replace(/\d+/g, "\\d+");

          let regex = new RegExp("^" + pattern);
          if (regex.test(lastText)) {
            lastText = lastText.replace(regex, "");
            break;
          }
        }
      }
      if (currentRange) {
        firstText = firstText.replace(new RegExp(currentRange + "$"), range);
        await dispatch("setEditCell", { text: firstText + lastText, range, cursorPosition: firstText.length });
        dispatch("setFormulaRange", { title: firstText + lastText, isMainRange: false });
      } else {
        await dispatch("setEditCell", {
          text: firstText + range + lastText,
          range,
          cursorPosition: (firstText + range).length,
        });
        dispatch("setFormulaRange", { title: state.editCell.text, isMainRange: false });
      }
    },
    async copyContent({ commit, state, dispatch, getters, rootState }, { isCut }) {
      const mainRange = getters.mainRange;
      const currentSheet = rootState.sheets.currentSheet;
      var contents = getters.getRangeValues({ range: mainRange.range });
      if (isCut) {
        hfInstance.cut({
          start: { sheet: currentSheet.sheetId, col: mainRange.range[0], row: mainRange.range[1] },
          end: { sheet: currentSheet.sheetId, col: mainRange.range[2], row: mainRange.range[3] },
        });
      } else {
        hfInstance.copy({
          start: { sheet: currentSheet.sheetId, col: mainRange.range[0], row: mainRange.range[1] },
          end: { sheet: currentSheet.sheetId, col: mainRange.range[2], row: mainRange.range[3] },
        });
      }
      //this will make sure to put " " for line breaks in single cells
      contents = helper.copy.utils.convertToStringObject(contents);
      localStorage.setItem("rangeMetadata", JSON.stringify({ contents, sourceRange: mainRange.range, isCut }));

      const newCellsData = contents.map((row) => row.join("\t")).join("\n");
      navigator.clipboard
        .writeText(newCellsData)
        .then(() => {
          dispatch(
            "addToast",
            {
              severity: "success",
              life: 3000,
              summary: "Text copied to clipboard",
            },
            { root: true }
          );
        })
        .catch((error) => {
          dispatch(
            "addToast",
            {
              severity: "error",
              life: 3000,
              summary: "Failed to copy text",
              detail: "Please try to copy contents of a cell",
            },
            { root: true }
          );
          console.log(error);
        });
    },
    async setArrow({ commit, dispatch, state }, { rowId, columnId, x }) {
      switch (state.arrow.activeCursor) {
        case CustomCursorTypes.Start: {
          commit("SET_ARROW", {
            startPlayerId: columnId,
            startPlayerX: x,
            activeCursor: CustomCursorTypes.End,
          });
          break;
        }
        case CustomCursorTypes.End: {
          const plusToMinus = state.arrow.startPlayerId?.includes("Plus") && columnId?.includes("Minus");
          columnId = plusToMinus ? columnId.replace("Minus", "Plus") : columnId;
          commit("SET_ARROW", {
            startPlayerX: 0,
            endPlayerId: columnId,
            activeCursor: CustomCursorTypes.Default,
          });
          // add new Arrow
          if (columnId)
            dispatch("addArrow", { rowId, startColumnId: state.arrow.startPlayerId, endColumnId: columnId });
          break;
        }
        case CustomCursorTypes.Default: {
          dispatch("pdesign/setEditMode", EditModes.Disable, { root: true });
          commit("SET_ARROW", {
            activeCursor: CustomCursorTypes.Start,
            rowId,
          });
          break;
        }
      }
    },
    clearFormulaMetaData({ state, getters, dispatch }, range) {
      helper.metaData.utils.removeFormulaMetaData(range);
    },

    async find({ state, commit, rootState, dispatch }, { text, matchCase, matchWholeWord, type, search }) {
      let totalMatches = 0;
      let allMatches = 0;
      let filteredResults = {};
      let allResults = {};
      let cellsContent = [];
      const dataMatrix = [];

      if (!state.current) return { totalMatches: 0, filteredResults: {} };
      if (!text || !text.trim()) {
        commit("SET_FILTERED_CELLS", filteredResults);
        dispatch("toggleRedrawCanvas");
        return { totalMatches: 0, filteredResults: {} };
      }
      for (const { sheetId, name } of rootState.sheets.allSheets) {
        const data = hfInstance.getSheetSerialized(sheetId);
        const escapeRegExp = (string) => string.replace(/[.*+?^=!:${}()|[\]\\]/g, "\\$&");
        const searchText = matchCase ? text : text.toLowerCase();
        const escapedSearchText = escapeRegExp(searchText);
        const regex = matchWholeWord
          ? new RegExp(`\\b${escapedSearchText}\\b`, matchCase ? "" : "i")
          : new RegExp(escapedSearchText, matchCase ? "" : "i");

        allResults[name] = {};

        data.forEach((row, rowIndex) => {
          row.forEach((cell, colIndex) => {
            if (cell !== null && regex.test(matchCase ? cell : String(cell)?.toLowerCase())) {
              cellsContent.push(cell);
              dataMatrix.push(cell);

              if (name === rootState.sheets.currentSheet.name) {
                filteredResults[`${rowIndex}_${colIndex}`] = name;
              }
              if (search == "Sheet") {
                if (name === rootState.sheets.currentSheet.name) {
                  allMatches += 1;
                  allResults[name][`${rowIndex}_${colIndex}`] = name;
                }
              } else {
                allMatches += 1;

                allResults[name][`${rowIndex}_${colIndex}`] = name;
              }
            }
          });
        });

        if (type == "By Column") {
          const sortedEntries = Object.entries(filteredResults)
            .map(([key, value]) => [key, key.split("_").map(Number), value])
            .sort((a, b) => a[1][1] - b[1][1] || a[1][0] - b[1][0])
            .map(([key, , value]) => [key, value]);

          filteredResults = Object.fromEntries(sortedEntries);
        }
      }

      totalMatches = Object.keys(filteredResults).length;
      commit("SET_FILTERED_CELLS", filteredResults);
      dispatch("toggleRedrawCanvas");
      return { totalMatches, filteredResults, cellsContent, allMatches, allResults, dataMatrix };
    },

    checkTeamValidity({ dispatch, state, rootGetters }, id) {
      // player should belong to same team
      const playerTeamId = rootGetters["players/teamId"](id);
      if (
        playerTeamId !== "DEFAULT" &&
        playerTeamId !== state.current.team_id &&
        !(playerTeamId === "PRIVATE" && state.current.team_id === null)
      ) {
        dispatch(
          "addToast",
          {
            ...i18n.global.tm("processDesigner.otherProcPlayer.failed"),
            severity: "info",
            life: 4000,
          },
          { root: true }
        );
        return false;
      }
      return true;
    },
    showNavigationCorner({ commit, state, dispatch, rootState }) {
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
          dispatch("toggleRedrawCanvas");
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.view.main.showNavigationCorner());
        },
      };
      stateHistory.snapshot(undoObj);
    },
    hideNavigationCorner({ commit, state, dispatch, getters }) {
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
          dispatch("toggleRedrawCanvas");
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.view.main.hideNavigationCorner());
        },
      };
      stateHistory.snapshot(undoObj);
    },
    async removeCornerData({ commit, state, rootState, dispatch }, { rowIds, columnIds }) {
      const currentSheet = rootState.sheets.currentSheet;
      const { width, height } = hfInstance.getSheetDimensions(currentSheet.sheetId);

      rowIds.forEach((rowId) => {
        const rowIndex = state.current.design.rowMap[rowId].index;
        const emptyArray = new Array(width).fill(null);

        hfInstance.setCellContents({ sheet: currentSheet.sheetId, row: rowIndex, col: 0 }, [emptyArray]);
      });
      columnIds.forEach((columnId) => {
        const columnIndex = state.current.design.columnMap[columnId].index;
        const emptyArray = new Array(height).fill([""]);

        hfInstance.setCellContents({ sheet: currentSheet.sheetId, col: columnIndex, row: 0 }, emptyArray);
      });
    },
    async updateLink({ commit, state, dispatch }, { linkId, title }) {
      const currentLink = state.current.design.links[linkId];
      if (!currentLink) return;
      dispatch(
        "smartSearch/loadProcessPlayers",
        { team: state.current.team, links: state.current.design.links },
        { root: true }
      );
      await dispatch("editCellContent", { id: currentLink.cellId, value: title });
    },
    /* ACTIONS WITH UNDO REDO FUNCTIONALITY */
    pasteContent({ commit, state, dispatch, rootState, rootGetters, getters }) {
      navigator.clipboard
        .readText()
        .then(async (pastedText) => {
          await dispatch("status", { updating: "updating" });
          const currentSheet = rootState.sheets.currentSheet;
          const normalizedData = pastedText.replace(/\r\n/g, "\n");
          pastedText = helper.copy.utils.parseClipboardData(normalizedData);
          const clipboardData = pastedText;
          const localData = localStorage.getItem("rangeMetadata");
          if (!clipboardData.length || !localData) return;
          let { contents, sourceRange, isCut } = JSON.parse(localData);

          const isCopiedFromKyra = helper.copy.utils.isCopiedFromKyra(clipboardData, contents);
          const shouldDataExpand = helper.copy.utils.shouldDataExpand(clipboardData);
          const targetRange = helper.copy.utils.getRefinedTargetRange(clipboardData, contents);

          // validate target range
          const targetCellIds = getters["rangeIds"](targetRange);
          const isInvalid = targetCellIds.some((id) => getters["isCellDisabled"](id));

          if (isInvalid) {
            return dispatch(
              "addToast",
              { severity: "error", life: 2000, summary: "Sorry! You have selected an Invalid Range." },
              { root: true }
            );
          }

          let newMatrix = clipboardData;
          // source is single cell but target is multiple cells
          if (shouldDataExpand) {
            const value = isCopiedFromKyra
              ? hfInstance.getCellSerialized({ sheet: currentSheet.sheetId, row: sourceRange[1], col: sourceRange[0] })
              : clipboardData[0][0];
            newMatrix = helper.copy.utils.getRefinedRangeData(
              value,
              targetRange,
              isCopiedFromKyra ? sourceRange : undefined
            );
          }

          let reverseArr = [];
          const undoObj = {
            undo: () => {
              reverseArr.forEach((func) =>
                (async () => {
                  await func();
                })()
              );
              dispatch("toggleRedrawCanvas");
            },
            redo: async () => {
              reverseArr = [];
              if (isCopiedFromKyra && !shouldDataExpand) {
                try {
                  hfInstance.paste({ sheet: currentSheet.sheetId, col: targetRange[0], row: targetRange[1] });
                } catch (error) {
                  console.log(error);
                }
              }
              reverseArr.push(await helper.content.main.set(targetRange, newMatrix));
              reverseArr.push(helper.style.main.copyStyleFromSourceToTarget(sourceRange, targetRange));
              if (isCut && isCopiedFromKyra) {
                reverseArr.push(helper.style.main.clearRange(sourceRange));
                reverseArr.push(await helper.content.main.remove(sourceRange));
                await navigator.clipboard.writeText(""); // Clear clipboard data
                localStorage.setItem("rangeMetadata", "");
              }
              dispatch("toggleRedrawCanvas");
            },
          };
          stateHistory.snapshot(undoObj);

          // newMatrix = getters.getRangeData({ range: targetRange });
          // // check if conflict with table update table header
          // const tables = rootGetters["table/allTablesInRange"](targetRange);
          // tables?.forEach((table) => {
          //   const headerRange = rootGetters["table/headerRange"](table);
          //   var contents = getters.getRangeData({ range: headerRange });

          //   let headerList = [];
          //   headerList = contents[0];
          //   dispatch(
          //     "table/updateTableDetails",
          //     { updatedTable: { ...table, headerList }, oldTable: table },
          //     { root: true }
          //   );
          // });

          // const [columnIndex, rowIndex] = getters.getCellCoordinate(state.activeCellId);
          // const isAFormula = hfInstance.doesCellHaveFormula({
          //   sheet: currentSheet.sheetId,
          //   row: rowIndex,
          //   col: columnIndex,
          // });
          // let activeCellValue = "";
          // if (isAFormula) {
          //   activeCellValue = hfInstance.getCellFormula({
          //     sheet: currentSheet.sheetId,
          //     row: rowIndex,
          //     col: columnIndex,
          //   });
          // } else {
          //   activeCellValue = hfInstance.getCellValue({
          //     sheet: currentSheet.sheetId,
          //     row: rowIndex,
          //     col: columnIndex,
          //   });
          // }
          // dispatch("setEditCell", { text: activeCellValue });
          // await dispatch("persistSelectedCells", { range: targetRange, value: newMatrix });
        })
        .catch((error) => {
          dispatch(
            "addToast",
            { severity: "error", life: 3000, summary: "Failed to read clipboard text" },
            { root: true }
          );
          console.log(error);
        })
        .finally(async () => {
          await dispatch("status", { updating: "updated" });
        });
    },
    async fill({ commit, state, dispatch, rootState, getters, rootGetters }, { initialRange, newRange }) {
      try {
        await dispatch("status", { updating: "updating" });

        const currentSheet = rootState.sheets.currentSheet;
        const fillHelper = new FillHelper(
          hfInstance,
          rootState,
          rootGetters,
          dispatch,
          currentSheet,
          initialRange,
          newRange
        );
        if (!fillHelper.direction) return;
        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            reverseArr.forEach(async (func) => await func());
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.fill.main.set(initialRange, newRange));
          },
        };
        stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async fillDirection({ commit, dispatch, state }, { range, direction }) {
      let initialRange;
      if (direction === "right") {
        initialRange = [range[0], range[1], range[0], range[3]];
      } else if (direction === "down") {
        initialRange = [range[0], range[1], range[2], range[1]];
      } else if (direction === "left") {
        initialRange = [range[2], range[1], range[2], range[3]];
      } else if (direction === "up") {
        initialRange = [range[0], range[3], range[2], range[3]];
      }
      dispatch("fill", { initialRange, newRange: range });
    },
    async fillSeries(
      { commit, dispatch, state, rootState },
      { range, seriesIn, type, dateUnit, trend, stepValue, stopValue }
    ) {
      await dispatch("status", { updating: "updating" });

      try {
        const currentSheet = rootState.sheets.currentSheet;
        if (!range || stepValue === 0) return;

        // Check if rowId or columnId is in mergedCellIds
        const isRowOrColumnMerged = helper.fill.utils.isRowOrColumnMerged(range, seriesIn, stepValue, stopValue);

        if (isRowOrColumnMerged) {
          // Show popup message and stop execution
          dispatch(
            "addToast",
            {
              severity: "error",
              life: 4000,
              summary: "Failed fill series",
              detail: "To do this, all the merged cells need to be the same size.",
            },
            { root: true }
          );
          return;
        }
        let initialRange;
        if (type === "AutoFill") {
          const maxData = getMaxDataInRange(range, seriesIn, hfInstance, currentSheet);
          initialRange = getInitialRange(range, maxData, seriesIn);
          return dispatch("fill", { initialRange, newRange: range });
        }
        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            reverseArr.forEach(async (func) => await func());
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(
              await helper.fill.main.series(range, seriesIn, type, dateUnit, trend, stepValue, stopValue)
            );
          },
        };
        stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async addArrow({ commit, dispatch, state }, { rowId, startColumnId, endColumnId }) {
      if (state.current.design.arrows[rowId]?.length >= 3 || !startColumnId || !endColumnId)
        return dispatch(
          "addToast",
          {
            summary: i18n.global.t("processDesigner.arrow.maxCount"),
            severity: "error",
            life: 4000,
          },
          { root: true }
        );
      let reverseArr = [];
      // to keep arrow id constant after undo and redo. it's necessary for update
      const newArrowId = uuidv4();
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.arrow.main.add(rowId, startColumnId, endColumnId, newArrowId));
        },
      };
      stateHistory.snapshot(undoObj);
    },
    deleteSelectedArrow({ commit, dispatch, state }) {
      const { rowId, id } = state.selectedArrow;
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.arrow.main.remove(rowId, id));
        },
      };
      stateHistory.snapshot(undoObj);
    },
    updateArrow({ commit, dispatch, state }, arrow) {
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.arrow.main.update(arrow));
        },
      };
      stateHistory.snapshot(undoObj);
    },
    moveRowArrow({ dispatch, state }, amount) {
      const rowId = state.selectedArrow.rowId;
      let reverseArr = [];

      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.arrow.main.move(rowId, amount));
        },
      };
      stateHistory.snapshot(undoObj);
    },
    async editCellContent({ commit, state, dispatch, rootState, getters }, { id, value }) {
      const [columnIndex, rowIndex] = getters.getCellCoordinate(id);
      const sheetId = rootState.sheets.currentSheet.sheetId;
      if (!columnIndex || !rowIndex) return;

      const prevRangeTitle = rangeSelection.getFormula();
      const prevActiveCellId = state.activeCellId;
      let reverseArr = [];

      const undoObj = {
        undo: async () => {
          reverseArr.forEach((func) =>
            (async () => {
              await func();
            })()
          );
          dispatch("toggleRedrawCanvas");
          dispatch("setFormulaRange", { title: prevRangeTitle, activeCellId: prevActiveCellId });
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.content.main.set([columnIndex, rowIndex, columnIndex, rowIndex], value));
        },
      };

      stateHistory.snapshot(undoObj);

      // **Check if HyperFormula returns an error**
      const cellValue = hfInstance.getCellValue({ sheet: sheetId, row: rowIndex, col: columnIndex });
      // **If cellValue is an error, trigger the error popup**
      if (cellValue?.type === "ERROR") {
        dispatch(
          "pdesign/setError",
          {
            show: true,
            type: "Error",
            summary: "Formula Error",
            detail: hyperFormulaErrorMessages[cellValue], // Get the related message
            buttons: [
              { text: "Cancel", type: "cancel" },
              { text: "Ok", type: "confirm" },
            ],
          },
          { root: true }
        );
      }
    },
    async editCellMetaData({ state, dispatch }, { id, key, value }) {
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          reverseArr.forEach(async (func) => await func());
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.metaData.main.edit(id, key, value));
        },
      };
      stateHistory.snapshot(undoObj);
    },
    async updateIcon({ commit, state, getters, dispatch }, icon) {
      try {
        await dispatch("status", { updating: "updating" });
        const mainRange = getters["mainRange"]?.range;

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.icon.main.set(icon, mainRange));
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async moveActivity(
      { commit, dispatch, state, getters, rootState, rootGetters },
      { sourceIndex, targetIndex, rowIds }
    ) {
      try {
        await dispatch("status", { updating: "updating" });

        const rows = state.current.design.rows;
        const columns = state.current.design.columns;
        const numRowsToMove = rowIds.length;
        for (let i = 0; i < numRowsToMove; i++) {
          const source = rows[sourceIndex + i];
          const target = rows[targetIndex + i];
          const targetRange = [0, target.index, columns.length - 1, target.index];
          const sourceRange = [0, source.index, columns.length - 1, source.index];

          const isconflict = rootGetters["table/tableHeaderConflict"](targetRange);
          const isTotalConflict = rootGetters["table/tableTotalConflict"](targetRange);
          const isSourceConflict = rootGetters["table/tableTotalConflict"](sourceRange);

          if (isconflict || isTotalConflict || isSourceConflict) {
            await dispatch("status", { updating: "updated" });
            return 0;
          }
          if (
            !(
              source.type === target.type && [RowTypes.Activity, RowTypes.RowGroup, RowTypes.Grid].includes(source.type)
            )
          )
            return;
        }

        if (targetIndex + rowIds.length > rows.length) return 0;

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.row.main.moveRowsFromState(sourceIndex, targetIndex, numRowsToMove));
            reverseArr.push(await helper.row.main.moveRowsFromHf(sourceIndex, targetIndex, numRowsToMove));
            reverseArr.push(
              await helper.style.main.moveRangeStyle(sourceIndex, numRowsToMove, "Y", sourceIndex <= targetIndex)
            );
            reverseArr.push(await helper.corner.main.reloadCorners());
            await helper.merge.utils.updateMergedCells();
            reverseArr.push(await helper.flow.main.moveShape(sourceIndex, targetIndex, numRowsToMove));
            dispatch("toggleRedrawCanvas");
          },
        };

        await stateHistory.snapshot(undoObj);
        return 1;
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async addRow({ commit, state, dispatch, getters, rootState }, { type, customRange } = {}) {
      try {
        await dispatch("status", { updating: "updating" });
        const mainRange = getters["mainRange"];
        let range = customRange ?? mainRange?.range;

        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);
        let prevActiveCellIndex = activeCellIndex;

        if (!customRange)
          [range, activeCellIndex] = helper.row.utils.refineRangeForAddition(range, activeCellIndex, type);

        if (activeCellIndex[1] < range[1] || activeCellIndex[1] > range[3]) {
          activeCellIndex = [range[0], range[1]];
        }

        const rowRange = [0, range[1], state.current.design.columns.length - 1, range[3]];
        const count = range[3] - range[1] + 1;
        const index = range[1];
        const rowIndexes = new Array(count).fill(0).map((item, i) => index + i);
        // keep row ids constant after every undo redo
        const newRowIds = new Array(count).fill(0).map((item) => uuidv4());
        let isFirstTime = true;
        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            const sortedReverseArr = reverseArr.sort((a, b) => a.prio - b.prio);
            for (const item of sortedReverseArr) {
              await item.func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push({ func: await helper.row.main.addRowsToState(index, count, type, newRowIds), prio: 0 });
            reverseArr.push({ func: await helper.row.main.addRowsToHf(index, count), prio: 0 });
            reverseArr.push({
              func: await helper.range.main.set(range, activeCellIndex, mainRange.range, prevActiveCellIndex),
              prio: 0,
            });

            if (state.current.type === ProcessTypes.Posting && type === RowTypes.RowGroup)
              reverseArr.push({ func: await helper.merge.main.mergeRowGroupColumnsAfterInsert(index, count), prio: 0 });
            if (state.current.type !== ProcessTypes.Grid && type === RowTypes.Activity) {
              reverseArr.push({ func: await helper.content.main.setActivityColumnContent(rowIndexes), prio: -1 });
              reverseArr.push({ func: await helper.flow.main.addShape(index, count), prio: -1 });
              if (isFirstTime) dispatch("cells/setArrow", { rowId: state.current.design.rows[0].id }, { root: true });
              isFirstTime = false;
            }
            reverseArr.push({ func: await helper.table.main.updateAllTableBelowAddedRows(rowRange, count), prio: 0 });
            reverseArr.push({ func: await helper.style.main.updateItems(index, count, true, "Y"), prio: 0 });
            dispatch("toggleRedrawCanvas");
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async addColumn({ commit, state, dispatch, getters, rootState }, { type, customRange }) {
      try {
        await dispatch("status", { updating: "updating" });

        const mainRange = getters["mainRange"];
        let range = customRange ?? mainRange?.range;

        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);
        let prevActiveCellIndex = activeCellIndex;

        if (!customRange)
          [range, activeCellIndex] = helper.column.utils.refineRangeForAddition(range, activeCellIndex, type);

        if (activeCellIndex[0] < range[0] || activeCellIndex[0] > range[2]) {
          activeCellIndex = [range[0], range[1]];
        }
        const columnRange = [range[0], 0, range[2], state.current.design.rows.length];

        const count = range[2] - range[0] + 1;
        const index = range[0];

        // keep column ids constant after every undo redo
        const newColumnIds = new Array(count).fill(0).map((item) => uuidv4());
        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const item of reverseArr) {
              await item.func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push({
              func: await helper.column.main.addColumnsToState(index, count, type, newColumnIds),
              prio: 0,
            });
            reverseArr.push({ func: await helper.column.main.addColumnsToHf(index, count), prio: 0 });
            reverseArr.push({
              func: await helper.range.main.set(range, activeCellIndex, mainRange.range, prevActiveCellIndex),
              prio: 0,
            });
            reverseArr.push({
              func: await helper.table.main.updateAllTableToLeftAddedColumns(columnRange, count),
              prio: 0,
            });
            reverseArr.push({ func: await helper.style.main.updateItems(index, count, true, "X"), prio: 0 });
            dispatch("toggleRedrawCanvas");
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async removeRows({ commit, state, dispatch, getters, rootGetters, rootState }, { customRange } = {}) {
      try {
        await dispatch("status", { updating: "updating" });
        const currentSheet = rootState.sheets.currentSheet;

        const mainRange = getters["mainRange"];
        let range = customRange ?? mainRange?.range;
        let type;
        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);
        let prevActiveCellIndex = activeCellIndex;
        [range, activeCellIndex, type] = helper.row.utils.refineRangeForAddition(range, activeCellIndex);

        const count = range[3] - range[1] + 1;
        const index = range[1];
        const { width } = hfInstance.getSheetDimensions(currentSheet.sheetId);
        const rowIds = state.current.design.rows.slice(index, index + count).map((item) => item.id);
        const rowRange = [0, range[1], state.current.design.columns.length - 1, range[3]];

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(
              await helper.metaData.main.remove([0, range[1], state.current.design.columns.length, range[3]])
            );
            reverseArr.push(await helper.row.main.removeRowsFromState(index, count));
            reverseArr.push(await helper.row.main.removeRowsFromHf([0, range[1], width, range[3]]));
            [range, activeCellIndex] = helper.range.utils.limitRangeWithinValidBound(range, activeCellIndex);
            reverseArr.push(await helper.range.main.set(range, activeCellIndex, mainRange.range, prevActiveCellIndex));
            if (state.current.type !== ProcessTypes.Grid) {
              // this.dispatch("customFlow/deleteShape", rowIds, { root: true });
              reverseArr.push(await helper.arrow.main.removeByRowIds(rowIds));
            }
            reverseArr.push(
              await helper.table.main.updateAllTableBelowAddedRows(rowRange, -1 * (range[3] - range[1] + 1))
            );
            reverseArr.push(await helper.style.main.updateItems(index, count, false, "Y"));
            dispatch("toggleRedrawCanvas");
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },

    async extract2DArrayFromCycleData({ commit, state, dispatch, getters, rootState }, data) {
      const headerRow = [
        "Cycle",
        "CompanyCode",
        "StartDate",
        "EndDate",
        "CycleText",
        "DeriveFuncArea",
        "SegmentName",
        "SegmentDescription",
        "Sortfield",
        "AssessmentCostElement",
        "SenderOrderFrom",
        "SenderOrderTo",
        "SenderOrderGroup",
        "SenderCostCenterFrom",
        "SenderCostCenterTo",
        "SenderCostCenterGroup",
        "SenderCostElementFrom",
        "SenderCostElementTo",
        "SenderCostElementGroup",
        "SenderValueRule",
        "Amount",
        "Origin",
        "Senders",
        "ReceiverCostCenterFrom",
        "ReceiverCostCenterTo",
        "ReceiverCostCenterGroup",
        "ReceiverOrderFrom",
        "ReceiverOrderTo",
        "ReceiverOrderGroup",
        "ReceiverRule",
        "VariablePortionType",
        "SelectionCriteriaFrom",
        "SelectionCriteriaTo",
        "GroupOfCelectionCriteria",
        "ReceiverTracingFactorReceiver",
        "ReceiverTracingFactorPercent",
      ];

      const cycle = data.header?.[0]?.Cycle || "";
      const companyCode = data.header?.[0]?.ControllingArea || "";
      const startDate = data.header?.[0]?.StartDate;
      const endDate = data.header?.[0]?.EndDate;
      const cycleText = data.header?.[0]?.CycleDescription || "";

      const rows = [];

      for (const segment of data.segments || []) {
        const segmentName = segment.header?.Name || "";
        const segmentDesc = segment.header?.SegmentDescription || "";
        const sortField = segment.header?.SortField || "";
        const assessmentElement = segment.header?.AssessmentCostElement || "";

        const senderValueRule = segment.header?.SenderRule || "";
        const receiverRule = segment.header?.ReceiverRule || "";
        const receiverTracingFactorReceiver = segment.header?.ReceiverFField1 || "";
        const receiverTracingFactorPercent = segment.header?.ReceiverWeightFact || "";
        const variablePortionType = segment.header?.SenderPercentage?.toString() || "";

        const elements = segment.elements || [];
        const keyFields = segment.keyFields || [];

        for (const element of elements) {
          const senderOrderFrom = element.Element2 || element.Element1 || element.Element3 || "";
          const amount = element.Value?.trim() || "";
          const origin = element.SrFlag || "";

          // Combine each element with all keyFields
          for (const keyField of keyFields) {
            rows.push([
              cycle, // Cycle
              companyCode, // Company Code
              startDate, // Start date
              endDate, // End date
              cycleText, // Cycle text
              "", // Derive Func. Area (not found)
              segmentName, // Segment name
              segmentDesc, // Segment description
              sortField, // Sortfield
              assessmentElement, // Assessment cost element
              senderOrderFrom, // Sender order from
              "", // Sender order to
              "", // Sender order group
              keyField.DBField === "KOSTL" ? keyField.FromValue || "" : "", // Sender cost center from
              keyField.DBField === "KOSTL" ? keyField.ToValue || "" : "", // Sender cost center to
              "", // Sender cost center group
              keyField.DBField === "KSTAR" ? keyField.FromValue || "" : "", // Sender cost element from
              keyField.DBField === "KSTAR" ? keyField.ToValue || "" : "", // Sender cost element to
              "", // Sender cost element group
              senderValueRule, // Sender Value Rule
              amount, // Amount
              origin, // Origin
              "", // Senders
              "", // Receiver cost center from
              "", // Receiver cost center to
              "", // Receiver Cost center group
              keyField.DBField === "AUFNR" ? keyField.FromValue || "" : "", // Receiver order from
              keyField.DBField === "AUFNR" ? keyField.ToValue || "" : "", // Receiver order to
              "", // Receiver order group
              receiverRule, // Receiver Rule
              variablePortionType, // Variable portion type
              "", // Selection criteria from
              "", // Selection criteria to
              "", // Group of selection criteria
              receiverTracingFactorReceiver, // Receiver tracing factor, receiver
              receiverTracingFactorPercent, // Receiver tracing factor, percent
            ]);
          }
        }
      }

      return [headerRow, ...rows];
    },

    async transferToGrid({ commit, state, dispatch, getters, rootState }) {
      try {
        const sapData = JSON.parse(localStorage.getItem("sapData"));
        const controllingArea = sapData.controllingArea;
        const cycle = sapData.cycle;
        const date = sapData.date;

        // Check if we have all required parameters
        if (!controllingArea || !cycle || !date) {
          throw new Error("Missing required parameters for grid transfer");
        }

        const response = await api.get(`/sap/raw?cycle=${controllingArea}${cycle}&date=${date}`);
        const rawData = response.data;
        const result = await dispatch("extract2DArrayFromCycleData", rawData);

        const mainRange = getters["mainRange"];
        let range = mainRange?.range || [10, 10, 10, 10];
        range[2] = range[0] + result[0].length - 1;
        range[3] = range[1] + result.length - 1;

        await dispatch("updateSelectedCells", { range, value: result });

        range[1] = range[1] - 1;

        const tableData = {
          _id: uuidv4(),
          tableName: "GridDataTable",
          tableRange: rangeIndexToLabel(range),
          sheetId: rootState.sheets.currentSheet.id,
          designId: state.current.id,
          sequenceValue: 2,
          headerVisible: true, // default value
          totalRowEnabled: true, // default value
          applyFormulaToEntireColumn: true,
          allowDynamicExpansion: true,
          view: {
            filterApplied: null,
            sortApplied: {},
          },
          styleId: Math.floor(Math.random() * 4) + "",
        };
        dispatch("table/createTable", tableData, { root: true });
      } catch (error) {
        console.error("Error fetching grid data:", error);
      }
    },

    async fetchGridData({ commit, state, dispatch, getters, rootState }) {
      try {
        const result = (await api.get(`fetchGridData`)).data;
        const mainRange = getters["mainRange"];
        let range = mainRange?.range;
        range[2] = range[0] + result[0].length - 1;
        range[3] = range[1] + result.length - 1;
        await dispatch("updateSelectedCells", { range, value: result });
        range[1] = range[1] - 1;

        const tableData = {
          _id: uuidv4(),
          tableName: "GridDataTable",
          tableRange: rangeIndexToLabel(range),
          sheetId: rootState.sheets.currentSheet.id,
          designId: state.current.id,
          sequenceValue: 2,
          headerVisible: true, // default value
          totalRowEnabled: true, // default value
          applyFormulaToEntireColumn: true,
          allowDynamicExpansion: true,
          view: {
            filterApplied: null,
            sortApplied: {},
          },
          styleId: Math.floor(Math.random() * 4) + "",
        };
        dispatch("table/createTable", tableData, { root: true });
      } catch (error) {
        console.error("Error fetching grid data:", error);
      }
    },
    async replace(
      { state, dispatch, rootState, getters },
      { findText, replaceText, filteredResults, dataMatrix, replaceOne }
    ) {
      const cellIds = [];
      const values = [];
      const selectedCellIds = [];
      const cellTexts = [];
      const sheetNames = [];
      let replaceCount = 0; // Counter for replacements

      for (const { sheetId, name, id } of rootState.sheets.allSheets) {
        Object.entries(filteredResults[name]).forEach(([key]) => {
          let [rowIndex, columnIndex] = key.split("_").map(Number);
          const cellId = getters.getCellIdByIndex([columnIndex, rowIndex]);
          selectedCellIds.push(cellId);
          cellTexts.push(replaceText);
          sheetNames.push(name);
          if (replaceOne != null) {
            if (Object.keys(replaceOne)[0] == key) {
              hfInstance.setCellContents({ sheet: sheetId, col: columnIndex, row: rowIndex }, [[replaceText]]);
            }
          } else {
            hfInstance.setCellContents({ sheet: sheetId, col: columnIndex, row: rowIndex }, [[replaceText]]);
          }
          dispatch("persistCellsByIds", { ids: [cellId], values: [replaceText], sheetName: name });
        });
      }

      dataMatrix.forEach((value) => {
        value = String(value);
        if (value && value.toLowerCase().includes(findText.toLowerCase())) {
          // Use global regex (`/gi`) to count all occurrences
          const regex = new RegExp(findText, "gi");
          replaceCount += (String(value).match(regex) || []).length; // Count occurrences
          // Replace all occurrences of findText
          const updatedValue = String(value).replace(regex, replaceText);
          values.push(updatedValue);
        } else {
          values.push(value);
        }
      });
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          for (const func of reverseArr) {
            await func();
          }

          dispatch("toggleRedrawCanvas");
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.content.main.editCellContentsByIds(cellIds, values));
        },
      };
      await stateHistory.snapshot(undoObj);
      return replaceCount; // Return the number of replacements
    },
    async addPlayer({ commit, state, rootState, dispatch, getters, rootGetters }, { ids, index }) {
      try {
        await dispatch("status", { updating: "updating" });
        // Remove duplicates in case user selected a player multiple times.
        ids = [...new Set(ids)];
        const count = ids.length;

        if (ids.length === 1 && (!dispatch("checkTeamValidity", ids[0]) || getters.playerExists(ids[0]))) return;

        const mainRange = getters["mainRange"];
        let range = mainRange?.range;

        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);

        const columns = ids.map((id) => ({ id: uuidv4(), type: ColumnTypes.Player }));
        const columnIds = columns.map((item) => item.id);
        const playerTitles = ids.map((id) => rootGetters["players/getPlayerById"](id).title);
        const cellIds = columns.map((column) => getCellId("Player", column.id));

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.column.main.addColumnsToState(index, count, ColumnTypes.Player, columnIds));
            reverseArr.push(await helper.column.main.addColumnsToHf(index, count));
            reverseArr.push(await helper.style.main.updateItems(index, count, true, "X"));
            await helper.content.main.editCellContentsByIds(cellIds, playerTitles);
            reverseArr.push(await helper.column.main.addLink(ids, "player", cellIds));
            reverseArr.push(await helper.range.main.set(range, activeCellIndex, range, activeCellIndex));
          },
        };
        await stateHistory.snapshot(undoObj);
        dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async addPostingPlayer({ commit, state, rootState, dispatch, getters, rootGetters }, { ids, index }) {
      try {
        await dispatch("status", { updating: "updating" });

        // Remove duplicates in case user selected a player multiple times.
        ids = [...new Set(ids)];

        if (ids.length === 1 && (!dispatch("checkTeamValidity", ids[0]) || getters.playerExists(ids[0]))) return;

        const mainRange = getters["mainRange"];
        let range = mainRange?.range;

        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);

        const columns = ids
          .map((id) => {
            const newId = uuidv4();
            return [
              { id: `${newId}-Plus`, type: ColumnTypes.Player },
              { id: `${newId}-Minus`, type: ColumnTypes.Player },
            ];
          })
          .flat();
        const count = columns.length;
        const columnIds = columns.map((item) => item.id);
        const cellIds = columns.map((column) => getCellId("Player", column.id));
        const plusSignPlayerCellIds = cellIds.filter((item) => item.includes("-Plus"));
        const plusColumnIds = columnIds.filter((item) => item.includes("-Plus"));
        const minusColumnIds = columnIds.filter((item) => item.includes("-Minus"));
        const plusSignCellIds = plusColumnIds.map((item) => `Sign_${item}`);
        const minusSignCellIds = minusColumnIds.map((item) => `Sign_${item}`);
        const toBeMergeRowTypes = [RowTypes.RowGroup, RowTypes.PlayerAttribute, RowTypes.Player];
        const playerTitles = ids.map((id) => rootGetters["players/getPlayerById"](id).title);

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.column.main.addColumnsToState(index, count, ColumnTypes.Player, columnIds));
            reverseArr.push(await helper.column.main.addColumnsToHf(index, count));
            reverseArr.push(await helper.merge.main.mergeRows(toBeMergeRowTypes, plusColumnIds));
            reverseArr.push(await helper.icon.main.add(plusSignCellIds, "icon-plus-circle"));
            reverseArr.push(await helper.icon.main.add(minusSignCellIds, "icon-minus-circle"));

            dispatch("toggleRedrawCanvas");

            reverseArr.push(await helper.style.main.updateItems(index, count, true, "X"));
            await helper.content.main.editCellContentsByIds(plusSignPlayerCellIds, playerTitles);
            reverseArr.push(await helper.column.main.addLink(ids, "player", cellIds));
            reverseArr.push(await helper.range.main.set(range, activeCellIndex, range, activeCellIndex));
            dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
          },
        };
        await stateHistory.snapshot(undoObj);
        dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async editPlayer({ commit, state, rootState, dispatch, getters, rootGetters }, { newPlayerId, type, cellId }) {
      const title = rootGetters["players/getPlayerById"](newPlayerId)?.title;
      let reverseArr = [];
      const undoObj = {
        undo: async () => {
          for (const func of reverseArr) {
            await func();
          }
          dispatch("toggleRedrawCanvas");
        },
        redo: async () => {
          reverseArr = [];
          reverseArr.push(await helper.column.main.editLink(newPlayerId, type, cellId));
          reverseArr.push(await helper.content.main.editCellContentsByIds([cellId], [title]));
          dispatch("toggleRedrawCanvas");
        },
      };
      await stateHistory.snapshot(undoObj);
    },
    async movePlayer(
      { commit, dispatch, state, rootState, getters, rootGetters },
      { sourceIndex, targetIndex, count }
    ) {
      try {
        await dispatch("status", { updating: "updating" });

        const columns = state.current.design.columns;
        const rows = state.current.design.rows;
        if (targetIndex === sourceIndex) return 0;

        // Check if all source and target columns are of the same type
        for (let i = 0; i < count; i++) {
          const source = columns[sourceIndex + i];
          const target = columns[targetIndex + i];

          if (
            !(
              source.type === target.type &&
              [ColumnTypes.Player, ColumnTypes.ColumnGroup, ColumnTypes.Grid].includes(source.type)
            )
          )
            return 0;

          const isConflict = rootGetters["table/tableHeaderConflict"]([target.index, 0, target.index, rows.length - 1]);
          const targetConflict = rootGetters["table/tableHeaderConflict"]([
            source.index,
            0,
            source.index,
            rows.length - 1,
          ]);

          if (isConflict || targetConflict) {
            await dispatch("status", { updating: "updated" });
            return 0;
          }
        }
        const isPostingProcess = state.current.type === ProcessTypes.Posting;

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            await helper.merge.utils.updateMergedCells();

            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.column.main.moveColumnsFromState(sourceIndex, targetIndex, count));
            reverseArr.push(await helper.column.main.moveColumnsFromHf(sourceIndex, targetIndex, count));
            reverseArr.push(
              await helper.style.main.moveRangeStyle(
                sourceIndex,
                count,
                "X",
                sourceIndex <= targetIndex,
                isPostingProcess ? 2 : 1
              )
            );
            reverseArr.push(await helper.corner.main.reloadCorners());
            await helper.merge.utils.updateMergedCells();
            dispatch("toggleRedrawCanvas");
          },
        };
        await stateHistory.snapshot(undoObj);

        return count;
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async removeColumns({ commit, state, dispatch, getters, rootState, rootGetters }, columnIds) {
      try {
        await dispatch("status", { updating: "updating" });

        const currentSheet = rootState.sheets.currentSheet;
        const mainRange = getters["mainRange"];
        let range = /*customRange ??*/ mainRange?.range;
        let type;
        let activeCellIndex = getters["getCellCoordinate"](state.activeCellId);
        let prevActiveCellIndex = [...activeCellIndex];
        // [range, activeCellIndex, type] = helper.column.utils.refineRangeForAddition(range, activeCellIndex);
        const count = range[2] - range[0] + 1;
        const index = range[0];
        const columnRange = [range[0], 0, range[2], state.current.design.rows.length];

        // Identify columns to be removed
        // const indexes = columnIds.map((columnId) => state.current.design.columnMap[columnId].index);
        const { height } = hfInstance.getSheetDimensions(currentSheet.sheetId);

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            dispatch("pdesign/setEditMode", EditModes.Disable, { root: true });
            if (state.current.type !== ProcessTypes.Grid) {
              // Identify and remove arrows
              reverseArr.push(await helper.arrow.main.removeByColumnIds(columnIds));
            }
            reverseArr.push(await helper.column.main.removeColumnLinks(index, count));
            reverseArr.push(await helper.column.main.removeColumnsFromState(index, count));
            reverseArr.push(await helper.column.main.removeColumnsFromHf([range[0], 0, range[2], height]));
            [range, activeCellIndex] = helper.range.utils.limitRangeWithinValidBound(range, activeCellIndex);
            reverseArr.push(await helper.range.main.set(range, activeCellIndex, mainRange.range, prevActiveCellIndex));
            reverseArr.push(await helper.table.main.updateAllTableToLeftAddedColumns(columnRange, -1 * count));
            reverseArr.push(await helper.style.main.updateItems(index, count, false, "X"));
            dispatch("toggleRedrawCanvas");
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async addComment({ commit, dispatch, state, getters, rootState }) {
      try {
        await dispatch("status", { updating: "updating" });

        const cellId = state.mergedCellIds[state.activeCellId]
          ? state.mergedCellIds[state.activeCellId].replace("_merged", "")
          : state.activeCellId;
        if (!cellId) return;

        const username = rootState.authUser?.username;
        await dispatch("editCellComment", { id: cellId, key: "comment", value: `${username}: \n` });
        state.visibleComment = {
          id: cellId,
          editMode: true,
        };
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async removeComment({ dispatch, state, getters }) {
      try {
        await dispatch("status", { updating: "updating" });

        const range = getters["mainRange"]?.range;
        if (!range) return;
        const cellIds = getters["rangeMatrix"](range);

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.metaData.main.removeComment(cellIds, "comment"));
            dispatch("toggleRedrawCanvas");
          },
        };

        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async persistCellsComment({ commit, state, rootState, dispatch }, cellIds) {
      const id = state.current.id;
      const currentSheetName = rootState.sheets.currentSheet.name;

      const cellIdsArray = Array.isArray(cellIds) ? cellIds : [cellIds];
      const payload = cellIdsArray.map((cellId) => ({
        sheetName: currentSheetName,
        id: cellId,
        data: state.current.design.cellsMetaData[cellId],
      }));
      const dataChunks = chunkArray(payload, 1000); // Adjust based on your needs
      if (dataChunks.length === 0) dataChunks.push([]); // In case all the cells are deleted.

      try {
        const promises = dataChunks.map((chunk) => {
          const compressedData = compressData({ payload: chunk });
          // Return the promise from api.patch
          return api.patch(`designs/${id}/update-cells-comment`, { compressedData });
        });

        // Execute all promises in parallel
        await Promise.all(promises);
      } catch (error) {
        console.error("Error saving bulk changes:", error);
      }
    },
    async editCellComment({ state, dispatch }, { id, key, value }) {
      state.current.design.cellsMetaData = produce(state.current.design.cellsMetaData, (cellsMetaData) => {
        if (!cellsMetaData[id]) {
          cellsMetaData[id] = {}; // Ensure the id key exists
        }
        cellsMetaData[id][key] = value; // Update the key with the new value
      });

      dispatch("toggleRedrawCanvas");
      await dispatch("persistCellsComment", id);
    },
    async updateSelectedCells({ commit, dispatch, state, rootState, getters }, { range, value }) {
      try {
        await dispatch("status", { updating: "updating" });
        const cellIds = getters["rangeIds"](range);

        const isInvalid = cellIds.some((id) => getters["isCellDisabled"](id));

        if (isInvalid) {
          dispatch(
            "addToast",
            { severity: "error", life: 2000, summary: "Sorry! You have selected an Invalid Range." },
            { root: true }
          );
          return;
        }

        let newValueMatrix = helper.copy.utils.getRefinedRangeData(value, range);
        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.content.main.set(range, newValueMatrix));
          },
        };

        await stateHistory.snapshot(undoObj);
      } catch (error) {
        console.error("Unable to update selected range", error);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async deleteSelectedCells({ state, dispatch, rootState, getters }) {
      await dispatch("status", { updating: "updating" });

      const mainRange = getters["mainRange"];

      let reverseArr = [];
      try {
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.content.main.remove(mainRange.range));
          },
        };

        await stateHistory.snapshot(undoObj);
      } catch (error) {
        console.error("Error in deleting selected data:", error);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async unmergeCells({ commit, dispatch, state, getters }) {
      try {
        await dispatch("status", { updating: "updating" });

        if (!getters.activeRange()?.id) return;

        state.current.design.mergedCells = produce(state.current.design.mergedCells, (mergedCells) => {
          const mergedCellIds = getters.rangeIds().filter((x) => x.endsWith("_merged"));

          // Update activeCellId if necessary
          if (mergedCellIds.includes(state.activeCellId)) {
            state.activeCellId = state.mergedCellIds[state.activeCellId].replace("_merged", "");
          }

          // Remove the merged cells
          mergedCellIds.forEach((id) => {
            delete mergedCells[id];
          });
        });

        dispatch("toggleRedrawCanvas");
        helper.merge.utils.loadMergedCellIds();
        await dispatch("persistDimensions", "mergedCells");
        dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async merge({ commit, dispatch, state, getters }) {
      try {
        await dispatch("status", { updating: "updating" });
        if (!getters.activeRange()?.id) return;
        const range = getters["mainRange"]?.range;

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            for (const func of reverseArr) {
              await func();
            }
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.merge.main.unmergeCells(range));
            reverseArr.push(await helper.merge.main.mergeCells(range));

            helper.merge.utils.loadMergedCellIds();
            dispatch("toggleRedrawCanvas");
            await dispatch("persistDimensions", "mergedCells");
            dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
          },
        };
        stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    async unmerge({ commit, dispatch, state, getters }) {
      try {
        await dispatch("status", { updating: "updating" });
        if (!getters.activeRange()?.id) return;
        const range = getters["mainRange"]?.range;

        let reverseArr = [];
        const undoObj = {
          undo: async () => {
            reverseArr.forEach(async (func) => await func());
            dispatch("toggleRedrawCanvas");
          },
          redo: async () => {
            reverseArr = [];
            reverseArr.push(await helper.merge.main.unmergeCells(range));

            helper.merge.utils.loadMergedCellIds();
            dispatch("toggleRedrawCanvas");
            await dispatch("persistDimensions", "mergedCells");
            dispatch("setScope", HotkeyScopes.ProcessDesigner, { root: true });
          },
        };
        await stateHistory.snapshot(undoObj);
      } catch (err) {
        console.error(err);
      } finally {
        await dispatch("status", { updating: "updated" });
      }
    },
    /* ACTION WITH API CALLS*/
    async persistCellsByIds({ state, dispatch, rootState, getters }, { ids, values, sheetName }) {
      const id = state.current.id;
      const currentSheetName = sheetName ?? rootState.sheets.currentSheet.name;

      try {
        const payload = { sheetName: currentSheetName, ids, values };
        const compressedData = compressData(payload);
        return api.patch(`designs/${id}/update-cells-by-ids`, { compressedData });
      } catch (error) {
        console.error("Error saving bulk changes:", error);
      }
    },
    async persistRanges({ state, dispatch, rootState, getters }, ranges) {
      const map = {};
      const currentSheetId = rootState.sheets.currentSheet.sheetId;
      const addRangeToMap = (range) => {
        for (let i = range[0]; i <= range[2]; i++) {
          for (let j = range[1]; j <= range[3]; j++) {
            const rowId = state.current.design.rows[j].id;
            const columnId = state.current.design.columns[i].id;
            const value = hfInstance.getCellSerialized({ sheet: currentSheetId, col: i, row: j });
            if (!map[rowId])
              map[rowId] = {
                columnIds: [],
                rowId: "",
                value: [],
              };

            map[rowId]["columnIds"].push(columnId);
            map[rowId]["rowId"] = rowId;
            map[rowId]["value"].push(value);
          }
        }
      };
      ranges.forEach((range) => addRangeToMap(range));
      await dispatch("persistChanges", Object.values(map));
    },
    async persistChanges({ state, dispatch, rootState, getters }, changes) {
      const id = state.current.id;
      const currentSheetName = rootState.sheets.currentSheet.name;

      const dataChunks = chunkArray(changes, 1000); // Adjust based on your needs
      if (dataChunks.length === 0) dataChunks.push([]); // In case all the cells are deleted.

      try {
        const promises = dataChunks.map((chunk, index) => {
          const payload = {
            sheetName: currentSheetName,
            data: chunk,
          };
          const compressedData = compressData(payload);
          // Return the promise from api.patch
          return api.patch(`designs/${id}/update-selected-cells`, { compressedData });
        });

        // Execute all promises in parallel
        await Promise.all(promises);
      } catch (error) {
        console.error("Error saving bulk changes:", error);
      }
    },
    async persistSelectedCells({ state, dispatch, rootState, getters }, { range, value }) {
      const values = Array.isArray(value) ? value : [value];
      const rowsInRange = getters.rowsInRange(range);
      const columnsInRange = getters.columnsInRange(range);
      const changes = trackChanges(rowsInRange, columnsInRange, values);

      await dispatch("persistChanges", changes);
    },
    async persistDimensions({ commit, state, rootState, dispatch }, dimension) {
      const id = state.current.id;
      const sheetName = rootState.sheets.currentSheet.name;
      const data = state.current.design[dimension];
      const dataChunks = chunkObject(data, 1000); // Adjust based on your needs
      const requestId = `req-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      if (dataChunks.length === 0) dataChunks.push([]); // In case all the cells are deleted.
      try {
        const promises = dataChunks.map((chunk, chunkId) => {
          const payload = {
            sheetName,
            dimension,
            data: chunk,
            chunkId,
            requestId,
            totalChunks: dataChunks.length,
          };
          const compressedData = compressData(payload);
          // Return the promise from api.patch
          return api.patch(`designs/${id}/update-dimensions`, { compressedData });
        });

        // Execute all promises in parallel
        await Promise.all(promises);
      } catch (error) {
        console.error("Error saving bulk changes:", error);
      }
    },
    async persistMoveRows({ commit, state, rootState }, { updatedRows }) {
      const id = state.current.id;
      const sheetName = rootState.sheets.currentSheet.name;
      const payload = {
        sheetName,
        updatedRows,
      };
      await api.patch(`designs/${id}/move-rows`, payload);
    },
    async persistMoveColumns({ commit, state, rootState }, { updatedColumns }) {
      const id = state.current.id;
      const sheetName = rootState.sheets.currentSheet.name;
      const payload = {
        sheetName,
        updatedColumns,
      };
      await api.patch(`designs/${id}/move-columns`, payload);
    },
    async addRowColumnMap({ state, rootState }, { index, rows, columns }) {
      try {
        const id = state.current.id;
        const sheetName = rootState.sheets.currentSheet.name;
        const payload = {
          sheetName,
          index,
          rows,
          columns,
        };
        await api.patch(`designs/${id}/add-row-column-map`, { payload });
      } catch (err) {
        console.error(err);
      }
    },
    async removeRowColumnMap({ state, rootState }, { rowIds, columnIds }) {
      try {
        const id = state.current.id;
        const sheetName = rootState.sheets.currentSheet.name;
        const payload = {
          sheetName,
          rowIds,
          columnIds,
        };
        await api.patch(`designs/${id}/remove-row-column-map`, { payload });
      } catch (err) {
        console.error(err);
      }
    },
    async removeNodesFromCellsContent({ state, rootState, dispatch }, { columnIds, rowIds }) {
      try {
        const id = state.current.id;
        const payload = {
          id,
          sheetName: rootState.sheets.currentSheet.name,
          columnIds,
          rowIds,
        };
        await api.patch(`designs/${id}/remove-node`, { payload });
      } catch (err) {
        console.error(err);
      }
    },
    async persistCellsMetaData({ commit, state, rootState, dispatch }, cellIds) {
      const id = state.current.id;
      const currentSheetName = rootState.sheets.currentSheet.name;
      const cellIdsArray = Array.isArray(cellIds) ? cellIds : [cellIds];
      const payload = cellIdsArray.map((cellId) => ({
        sheetName: currentSheetName,
        id: cellId,
        data: state.current.design.cellsMetaData[cellId] ?? "",
      }));
      const dataChunks = chunkArray(payload, 1000); // Adjust based on your needs
      if (dataChunks.length === 0) dataChunks.push([]); // In case all the cells are deleted.

      try {
        const promises = dataChunks.map((chunk) => {
          const compressedData = compressData({ payload: chunk });
          // Return the promise from api.patch
          return api.patch(`designs/${id}/update-cells`, { compressedData });
        });

        // Execute all promises in parallel
        await Promise.all(promises);
      } catch (error) {
        console.error("Error saving bulk changes:", error);
      }
    },
    async persistProperty({ commit, state, dispatch }, { key, value, designId }) {
      const id = designId ?? state.current.id;
      await api.patch(`designs/${id}/update-property`, { key, value });
    },
    async updateSheetProps({ rootState, state }, { key, value }) {
      const id = state.current.id;
      const sheetName = rootState.sheets.currentSheet.name;
      return api.patch(`designs/${id}/update-sheet-props`, { sheetName, key, value });
    },
  },
  getters: {
    cellValue: (state, getters, rootState) => (rowIndex, columnIndex, sheetId) => {
      sheetId = sheetId ?? rootState.sheets.currentSheet.sheetId;
      return hfInstance.getCellValue({ sheet: sheetId, row: rowIndex, col: columnIndex }) ?? "";
    },
    cellText: (state, getters, rootState) => (rowIndex, columnIndex, sheetId) => {
      sheetId = sheetId ?? rootState.sheets.currentSheet.sheetId;
      return hfInstance.getCellSerialized({ sheet: sheetId, row: rowIndex, col: columnIndex }) ?? "";
    },
    firstNonEmptyCell:
      (state, getters) =>
      ({ range }) => {
        const rangeData = getters.getRangeData({ range });
        return rangeData?.flat().find((cell) => cell != null && cell !== "") ?? null;
      },

    getCellIdByIndex: (state) => (coordinate) => {
      const columnId = state.current.design.columns[coordinate[0]].id;
      const rowId = state.current.design.rows[coordinate[1]].id;
      return getCellId(rowId, columnId);
    },
    getCellCoordinate: (state, getters) => (cellId) => {
      const [rowId, columnId] = cellId?.split("_");
      const columnIndex = state.current.design.columnMap[columnId]?.index;
      const rowIndex = state.current.design.rowMap[rowId]?.index;
      return [columnIndex, rowIndex];
    },
    getCellCoordinateInRange: (state, getters) => (cellId, range) => {
      const [columnIndex, rowIndex] = getters.getCellCoordinate(cellId);
      return [columnIndex - range[0], rowIndex - range[1]];
    },
    cellIdByIndexInRange: (state) => (columnIndex, rowIndex, range) => {
      const { columns, rows } = state.current?.design;
      let columnId = columns[range[0] + columnIndex].id;
      let rowId = rows[range[1] + rowIndex].id;
      return getCellId(rowId, columnId);
    },
    getCellIndexById: (state, getters, rootState) => (id) => {
      const [rowId, columnId] = splitCellId(id);
      const rowIndex = state.current?.design.rowMap?.[rowId]?.index;
      const columnIndex = state.current?.design.columnMap?.[columnId]?.index;
      return [columnIndex, rowIndex];
    },
    getRangeByCellId: (state, getters) => (cellId) => {
      const mergeId = cellId.includes("_merged")
        ? cellId
        : state.mergedCellIds
        ? state.mergedCellIds[cellId]
        : undefined;
      if (mergeId) {
        const [columnIndex, rowIndex] = getters.getCellCoordinate(mergeId.replace("_merged", ""));
        const mergedCell = state.current.design.mergedCells[mergeId];
        const { rowSpan, colSpan } = getters.getRowAndColSpan(mergedCell);
        return [columnIndex, rowIndex, columnIndex + colSpan - 1, rowIndex + rowSpan - 1];
      } else {
        const [columnIndex, rowIndex] = getters.getCellCoordinate(cellId);
        return [columnIndex, rowIndex, columnIndex, rowIndex];
      }
    },
    getRowVisibility: (state, getters, rootState) => (id) => {
      if (rootState.views.activeCorner === ActiveCorners.NavigationCorner) return true;

      return !(rootState.views.activeView?.rows[id]?.show === "0");
    },
    getRowVisibilityByIndex: (state, getters, rootState) => (index) => {
      if (rootState.views.activeCorner === ActiveCorners.NavigationCorner) return true;
      const id = state.current.design.rows[index].id;
      return getters.getRowVisibility(id);
    },
    getColumnVisibility: (state, getters, rootState) => (id) => {
      if (rootState.views.activeCorner === ActiveCorners.NavigationCorner) return true;

      return !(rootState.views.activeView?.columns[id]?.show === "0");
    },
    getColumnVisibilityByIndex: (state, getters, rootState) => (index) => {
      if (rootState.views.activeCorner === ActiveCorners.NavigationCorner) return true;
      const id = state.current.design.columns[index].id;
      return getters.getColumnVisibility(id);
    },
    getCellVisibility: (state, getters, rootState) => (id) => {
      if (rootState.views.activeCorner === ActiveCorners.NavigationCorner) return true;
      const [rowId, columnId] = splitCellId(id);
      return getters.getRowVisibility(rowId) && getters.getColumnVisibility(columnId);
    },
    rangeMatrix: (state, getters, rootState) => (range) => {
      if (!range) range = getters.activeRange()?.range;
      if (!range) return [];

      const sortedRange = sortRange(range);
      const cellIds = [];

      const rows = state.current.design.rows;
      const columns = state.current.design.columns;

      for (let i = sortedRange[1]; i <= sortedRange[3]; i++) {
        cellIds.push([]);
        for (let j = sortedRange[0]; j <= sortedRange[2]; j++) {
          const cellId = getCellId(rows[i].id, columns[j].id);
          cellIds[cellIds.length - 1].push(cellId);
        }
      }
      return cellIds;
    },
    getLastCellIdInRange: (state, getters) => (range) => {
      if (!range) range = getters.activeRange()?.range;
      if (!range) return [];

      const sortedRange = sortRange(range);

      const rows = state.current.design.rows;
      const columns = state.current.design.columns;
      const cellId = getCellId(rows[sortedRange[3]].id, columns[sortedRange[2]].id);
      return cellId;
    },
    rangeIds: (state, getters, rootState) => (range) => {
      if (!range) range = getters.activeRange()?.range;
      if (!range) return [];

      const sortedRange = sortRange(range);
      const cellIds = new Set();

      const rows = state.current.design.rows;
      const columns = state.current.design.columns;

      for (let i = sortedRange[1]; i <= sortedRange[3]; i++) {
        for (let j = sortedRange[0]; j <= sortedRange[2]; j++) {
          const cellId = getCellId(rows[i].id, columns[j].id);
          cellIds.add(state.mergedCellIds ? state.mergedCellIds[cellId] || cellId : cellId);
        }
      }
      return [...cellIds];
    },
    isRange: (state, getters, rootState) => (range) => {
      if (!range) range = getters.activeRange()?.range;
      if (!range) return [];

      const sortedRange = sortRange(range);
      const cellIds = new Set();

      const rows = state.current.design.rows;
      const columns = state.current.design.columns;

      for (let i = sortedRange[1]; i <= sortedRange[3]; i++) {
        for (let j = sortedRange[0]; j <= sortedRange[2]; j++) {
          const cellId = getCellId(rows[i].id, columns[j].id);
          cellIds.add(state.mergedCellIds[cellId] || cellId);
          if (cellIds.size > 1) return true;
        }
      }
      return false;
    },
    getRangeData:
      (state, getters, rootState) =>
      ({ range }) => {
        if (!range) range = getters.activeRange()?.range;
        if (!range) return [];

        let sortedRange = sortRange(range);
        return hfInstance.getRangeSerialized({
          start: { sheet: rootState.sheets.currentSheet.sheetId, col: sortedRange[0], row: sortedRange[1] },
          end: { sheet: rootState.sheets.currentSheet.sheetId, col: sortedRange[2], row: sortedRange[3] },
        });
      },
    getRangeValues:
      (state, getters, rootState) =>
      ({ range }) => {
        if (!range) range = getters.activeRange()?.range;
        if (!range) return [];

        let sortedRange = sortRange(range);
        return hfInstance.getRangeValues({
          start: { sheet: rootState.sheets.currentSheet.sheetId, col: sortedRange[0], row: sortedRange[1] },
          end: { sheet: rootState.sheets.currentSheet.sheetId, col: sortedRange[2], row: sortedRange[3] },
        });
      },
    rowsInRange: (state, getters, rootState) => (range) => {
      if (!range) range = getters.activeRange().range;
      if (!range) return [];

      const rows = state.current.design.rows;
      const sortedRange = sortRange(range);

      return rows.slice(sortedRange[1], sortedRange[3] + 1).map((item) => item.id);
    },
    columnsInRange: (state, getters, rootState) => (range) => {
      if (!range) range = getters.activeRange().range;
      if (!range) return [];

      const columns = state.current.design.columns;
      const sortedRange = sortRange(range);

      return columns.slice(sortedRange[0], sortedRange[2] + 1).map((item) => item.id);
    },
    playerExists: (state, getters, rootState) => (playerId) => {
      return !!state.current.design.links[playerId];
    },
    isCellDisabled: (state, getters, rootState) => (cellId) => {
      const [rowId, columnId] = cellId.split("_");

      const row = state.current.design.rowMap[rowId];
      const column = state.current.design.columnMap[columnId];

      if (!row || !column) return false;
      const disabledRowIds = ["Header", "Letter", "Blank"];
      const disabledColumnIds = ["Header", "Blank", "Number"];
      const disabledCellIds = ["Show_Show", "Show_Size", "Size_Show", "Size_Size"];

      if (
        disabledRowIds.includes(rowId) ||
        disabledColumnIds.includes(columnId) ||
        disabledCellIds.includes(cellId) ||
        (row.type === RowTypes.Activity && column.type === ColumnTypes.Flow) ||
        ((row.type === RowTypes.Player || row.type === RowTypes.Sign) && column.type === ColumnTypes.Player)
      )
        return true;

      return false;
    },
    ranges: (state, getters, rootState) => () => {
      const { columns, rows } = state.current?.design;

      return state.formulaRanges.map((item) => {
        const [col1, row1, col2, row2] = item.range;

        const getColumnId = (col) => columns[col]?.id || columns[col - 1]?.id;
        const getRowId = (row) => rows[row]?.id || rows[row - 1]?.id;

        const col1Index = state.current.design.columnMap[getColumnId(col1)]?.index;
        const col2Index = state.current.design.columnMap[getColumnId(col2)]?.index;
        const row1Index = state.current.design.rowMap[getRowId(row1)]?.index;
        const row2Index = state.current.design.rowMap[getRowId(row2)]?.index;

        return {
          id: item.id,
          range: sortRange([col1Index, row1Index, col2Index, row2Index]),
          mode: item.mode,
        };
      });
    },
    mainRange: (state, getters, rootState) => {
      const range = state.formulaRanges[0];
      if (!range) return;

      return getters.activeRange(range.id);
    },
    activeRange: (state, getters, rootState) => (rangeId) => {
      if (!rangeId) rangeId = rangeSelection.activeRangeId;

      const range = state.formulaRanges.find((item) => item.id === rangeId);
      if (!range) return;

      const [col1, row1, col2, row2] = sortRange(range.range);

      return {
        id: range.id,
        range: [col1, row1, col2, row2],
      };
    },
    rangeIcons: (state, getters, rootState) =>
      getters.rangeIds().map((id) => state.current.design.cellsMetaData[id]?.icons),
    getRowAndColSpan: (state, getters, rootState) => (mergedCell) => {
      return {
        colSpan:
          state.current.design.columnMap[mergedCell.columns.endColumnId].index -
          state.current.design.columnMap[mergedCell.columns.startColumnId].index +
          1,
        rowSpan:
          state.current.design.rowMap[mergedCell.rows.endRowId].index -
          state.current.design.rowMap[mergedCell.rows.startRowId].index +
          1,
      };
    },
    getRowsColumnsFromMaps: (state) => (rowMap, columnMap) => {
      const rows = Object.entries(rowMap)
        .map(([id, { type, index }]) => ({ id, type, index }))
        .sort((a, b) => a.index - b.index);

      const columns = Object.entries(columnMap)
        .map(([id, { type, index }]) => ({ id, type, index }))
        .sort((a, b) => a.index - b.index);

      return { rows, columns };
    },
  },
};
